import { CompletionRange, FraudCheckStatusFilter, Primary_Transaction_Status } from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { UseAdvancedQueryParamParams } from '@occc/utils';
import { isDateTimeValid, parseDate } from '@occc-app/lib/date';
import {
  FraudCheckStatusFilterType,
  TransactionStatusFilterType,
} from './transactions-filter-form.types';

export const TRANSACTION_STATUS_ALL = 'ALL';
export const FRAUD_CHECK_STATUS_ALL = 'ALL';

export const transactionStatusFilterOptions = [
  { label: 'View All', value: TRANSACTION_STATUS_ALL },
  { label: 'Active', value: Primary_Transaction_Status.Active },
  { label: 'Completed', value: Primary_Transaction_Status.Completed },
  { label: 'Failed', value: Primary_Transaction_Status.Failed },
  { label: 'Refunding', value: Primary_Transaction_Status.Refunding },
  { label: 'Voiding', value: Primary_Transaction_Status.Voiding },
];

export const fraudCheckStatusFilterOptions = [
  { label: 'View All', value: FRAUD_CHECK_STATUS_ALL },
  { label: 'Flagged', value: FraudCheckStatusFilter.Fraudulent },
  { label: 'Safe', value: FraudCheckStatusFilter.NotFraudulent },
];

export const transactionCompletedAtOptions = [
  {
    label: 'Last Hour',
    value: CompletionRange.LastHour,
  },
  {
    label: 'Last 6 hours',
    value: CompletionRange.Last_6Hours,
  },
  {
    label: 'Last 24 hours',
    value: CompletionRange.Last_24Hours,
  },
  {
    label: 'Yesterday',
    value: CompletionRange.Yesterday,
  },
  {
    label: 'Custom Range',
    value: CompletionRange.CustomRange,
  },
];

export const START_DATE_PARAM = 'startDate';
export const END_DATE_PARAM = 'endDate';
export const TRANSACTION_STATUS_PARAM = 'status';
export const PHONE_NUMBER_PARAM = 'phoneNumber';
export const MIN_AMOUNT_PARAM = 'minAmount';
export const MAX_AMOUNT_PARAM = 'maxAmount';
export const FRAUD_CHECK_STATUS_PARAM = 'fraudCheckStatus';
export const TRANSACTION_COMPLETED_AT_PARAM = 'transactionCompletedAt';
export const LOCATION_UUID_PARAM = 'locationUuid';

export const defaultDateQueryParams: Pick<
  UseAdvancedQueryParamParams<Date | undefined>,
  'beforeParamName' | 'afterParamName' | 'defaultValue' | 'readValidator' | 'parse' | 'format'
> = {
  defaultValue: undefined,
  readValidator: (value): value is Date => {
    if (typeof value !== 'string') {
      return false;
    }

    return isDateTimeValid(parseDate(value));
  },
  parse: parseDate,
  format: (date) => date.toISOString(),
};

export const startDateQueryParams: UseAdvancedQueryParamParams<Date | undefined> = {
  paramName: START_DATE_PARAM,
  ...defaultDateQueryParams,
};

export const endDateQueryParams: UseAdvancedQueryParamParams<Date | undefined> = {
  paramName: END_DATE_PARAM,
  ...defaultDateQueryParams,
};

export const transactionStatusQueryParams: UseAdvancedQueryParamParams<TransactionStatusFilterType> =
  {
    paramName: TRANSACTION_STATUS_PARAM,
    allowedValues: [...Object.values(Primary_Transaction_Status), TRANSACTION_STATUS_ALL],
    defaultValue: TRANSACTION_STATUS_ALL,
  };

export const fraudCheckStatusQueryParams: UseAdvancedQueryParamParams<FraudCheckStatusFilterType> =
  {
    paramName: FRAUD_CHECK_STATUS_PARAM,
    allowedValues: [...Object.values(FraudCheckStatusFilter), FRAUD_CHECK_STATUS_ALL],
    defaultValue: FRAUD_CHECK_STATUS_ALL,
  };

export const defaultTransactionCompletedAtQueryParams: UseAdvancedQueryParamParams<
  CompletionRange | undefined
> = {
  paramName: TRANSACTION_COMPLETED_AT_PARAM,
  allowedValues: Object.values(CompletionRange),
  defaultValue: undefined,
};

export const MIN_PHONE_NUMBER_LENGTH_FOR_SEARCH = 5;
